var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Backdrop } from "@material-ui/core";
import { cloneElement, isValidElement, useCallback, useState, } from "react";
import { ModalContext } from "./ModalContext";
export var ModalProvider = function (_a) {
    var children = _a.children;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = useState(), content = _c[0], setContent = _c[1];
    var handlePresent = useCallback(function (modalContent) {
        setContent(modalContent);
        setIsOpen(true);
    }, [setContent, setIsOpen]);
    var handleDismiss = useCallback(function () {
        setContent(undefined);
        setIsOpen(false);
    }, [setContent, setIsOpen]);
    return (_jsxs(ModalContext.Provider, __assign({ value: {
            isOpen: isOpen,
            content: content,
            onPresent: handlePresent,
            onDismiss: handleDismiss,
        } }, { children: [children, isOpen && (_jsx(Backdrop, __assign({ open: isOpen }, { children: isValidElement(content) &&
                    cloneElement(content, {
                        isOpen: isOpen,
                        onDismiss: handleDismiss,
                    }) }), void 0))] }), void 0));
};
